import React, { createContext, useContext, useState } from 'react';
import superAdminApi from '../utils/superAdminApi';

// ── Context مصادقة مستقل تماماً عن AuthContext و DistributorAuthContext ──
// جلسة مالك المنصة محفوظة تحت مفتاح sa_token فقط في localStorage. لا يوجد
// endpoint للتحقق من التوكن (مثل /auth/me) في الباك إند، لذا نعتبر وجود
// التوكن كافياً لعرض اللوحة، وأي طلب فعلي يفشل بـ 401/403 سيُعيد التوجيه
// تلقائياً لصفحة الدخول عبر superAdminApi.js.
const SuperAdminAuthContext = createContext(null);

export const SuperAdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('sa_token'));

  const login = async (password) => {
    const res = await superAdminApi.post('/login', { password });
    localStorage.setItem('sa_token', res.data.token);
    setToken(res.data.token);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('sa_token');
    setToken(null);
  };

  return (
    <SuperAdminAuthContext.Provider value={{ token, isAuthenticated: !!token, login, logout }}>
      {children}
    </SuperAdminAuthContext.Provider>
  );
};

export const useSuperAdminAuth = () => useContext(SuperAdminAuthContext);
